export default __webpack_public_path__ + "static/b4-4e06eb3c5c062b2990a94f885257e753.png";